const getBackendUrl = () => {
  let url = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
  if (url && !url.startsWith("http")) {
    url = `https://${url}`;
  }
  // Render fromService host can be host-only (e.g. carnatic-backend-x4y1); normalize so requests resolve
  try {
    const u = new URL(url);
    if (u.hostname && !u.hostname.includes(".") && u.hostname.includes("carnatic-backend")) {
      url = `https://${u.hostname}.onrender.com`;
    }
  } catch (_) { /* leave url unchanged */ }
  return url.replace(/\/$/, "");
};

export const BACKEND_URL = getBackendUrl();
